import { api } from './client';

export const maintenanceStatsApi = {
  async getStats() {
    const response = await api.get('equipment/maintenance/stats/');
    return response.data;
  },
};
